<template>
  <div>
    <BarHeading>Software</BarHeading>
    <div class="flex relative z-0 overflow-hidden mt-4">
      <div :logo="logo" v-for="(logo, idx) in productLogos" :key="idx">
        <img :src="logo.url" :alt="logo.product" :title="logo.product" class="w-8 md:w-12 mr-4"/>
      </div>
    </div>
  </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";
import BarHeading from "./shared/BarHeading.vue";

export default {
  name: "SessionCompatibilityBlock",
  components: {BarHeading},
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  computed: {
    productLogos() {
      let logos = [];
      if ("productCompatibility" in this.session) {
        this.session.productCompatibility.forEach(product => {
          logos.push({
                url:
                    sanityImageBuilder
                        .image(product.logo)
                        .width(200)
                        .url(),
                product: product.productName
              }
          );
        });
      }
      return logos;
    }
  }
};
</script>

<style scoped></style>
